import { gql } from '@apollo/client';

export const QUERY = gql`
  query Member($organizationId: Int!, $memberId: Int!) {
    member(organizationId: $organizationId, memberId: $memberId) {
      id
      firstName
      lastName
      birthdate
      gender
      organizationId
      joinedAt
      seasonParticipants(filter: { isArchived: null }) {
        season {
          id
          name
          isArchived
          program {
            id
            name
          }
        }
        referenceSeasonId
        seasonParticipantId
        seasonParticipantType
        division {
          id
          name
        }
        team {
          id
          name
        }
        participationRoles {
          name
        }
        registration {
          id
          type
          registrationFormId
          registrationFormName
          orderNumber
          orderId
          registrationUrl
          registrationPaymentStatus
        }
        invitationStatus
      }
      phoneNumbers {
        id
        number
        label
      }
      emailAddresses {
        id
        email
      }
      addresses {
        id
        line1
        line2
        city
        state
        postal_code
        country
      }
      contacts {
        firstName
        lastName
        label
        emailAddresses {
          id
          email
        }
        addresses {
          id
          line1
          line2
          city
          state
          postalCode
          country
        }
        phoneNumbers {
          id
          number
          label
        }
      }
    }
  }
`;
